<template>

    <div>

        <main id="content" class="relative w-full pt-12 sm:pt-16 xl:pt-16">

            <section class="h-auto w-full flex flex-col items-center relative z-20">

                <div class="max-w-[calc(100%-3rem)] sm:px-4 md:px-0 sm:max-w-1.5xl xl:max-w-8xl mx-auto w-full">

                    <h1 class="text-black text-4xl sm:text-4.5xl md:text-5xl lg:text-5xl xl:text-6xl font-medium mb-8 sm:mb-10 w-full relative text-center">
                        {{$root.translateString('complete_order')}}
                    </h1>

                    <!-- <p class="text-secondary-400 text-lg xl:text-xl 2.5xl:text-1.5xl !leading-snug max-w-[45ch] text-center mx-auto mb-12 sm:mb-20 px-6" v-html="$root.translateString('gift-message-p')" v-if="should_be_shipped"></p> -->

                    <!-- not logged -->

                    <div class="w-full flex flex-col xl:flex-row space-y-18 sm:space-y-24 xl:space-y-0 xl:space-x-12 2xl:space-x-15 2.5xl:space-x-20">

                        <div class="relative flex-grow space-y-18 xs:space-y-24">

                            <!-- ///////////////////// DATI PERSONALI -->

                            <div v-if="!isLogged" class="w-full relative">

                                <div class="relative w-full flex items-center space-x-4 mb-12">
                                    <span class="bg-primary/10 p-3 w-10 h-10 flex justify-center items-center text-primary text-base rounded-full">
                                        <span>1</span>
                                    </span>
                                    <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase text-center">
                                        {{$root.translateString('personal_details')}}
                                    </span>
                                </div>
                                <div class="relative w-full" v-if="!isLogged">
                                    <div class="grid w-full lg:grid-cols-2 gap-y-10 sm:gap-y-10 2xl:gap-y-10 gap-x-10 xl:gap-x-12 2xl:gap-x-14">

                                        <!-- <div class="small-banner d-flex align-items-center p-3 mb-3">
                                            <a class="cover" href="javascript:void(0)" @click="summonPopup"></a>
                                            <img alt="login" class="mr-1" src="/images/area-utente/user-gold.svg" width="25"/>
                                            <p class="ml-1 pl-2 torna-prodotti-link text-lightgrey text-smaller-85 mb-0 d-inline-flex flex-grow-1">
                                                {{$root.translateString('have-an-account')}}
                                                <span class="ml-2 text-gold" href="javascript:void(0)" @click="toggleLogin">
                                                    <span>{{$root.translateString('login-now')}}</span>
                                                </span>
                                            </p>
                                            <span class="arrow mr-1"><img width="32" src="/images/svg/roeno-17.svg" alt="dettagli"></span>
                                        </div> -->

                                        <span class="relative w-full block col-span-2 lg:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input @focus="validation.new_user.name.state = null" name="name" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="new_user.name" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('name')}}</label>
                                            </span>
                                            <span v-if="validation.new_user.name.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.new_user.name.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block col-span-2 lg:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input @focus="validation.new_user.email.state = null" name="email" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="email" v-model="new_user.email" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">E-mail</label>
                                            </span>
                                            <span v-if="validation.new_user.email.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.new_user.email.message }}
                                            </span>
                                        </span>

                                        <!-- <div class="checkout-container-row-2__checkbox mt-4 pt-3">
                                            <div class="checkbox-styles mt-3">
                                                <div class="checkbox">
                                                    <input data-lpignore="true" id="create_account" type="checkbox" v-model="new_user.create_account">
                                                    <label class="d-inline-block w-100" for="create_account"></label>
                                                </div>
                                                <label for="create_account" class="checkbox-styles__link mb-0">
                                                    {{$root.translateString('create-new-account')}}
                                                </label>
                                            </div>
                                        </div> -->

                                        <span class="flex flex-col space-y-3 w-full justify-start col-span-2">
                                            <span class="flex items-center space-x-3">
                                                <span class="h-6 w-6 relative block flex-shrink-0">
                                                    <input name="privacy" id="privacy" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="new_user.privacy">
                                                    <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-black"></span>
                                                </span>
                                                <label for="privacy" class="cursor-pointer">
                                                    <span class="text-black/50 block text-xs sm:text-sm xl:text-xs !leading-none">
                                                        {{$root.translateString('acceptance')}} &nbsp;<a class="text-black" target="_blank" :href="'/' + lang + '/privacy-policy'">{{$root.translateString('acceptance_link')}}</a>
                                                    </span>
                                                </label>
                                            </span>
                                            <span v-if="validation.new_user.privacy.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.new_user.privacy.message }}
                                            </span>
                                        </span>



                                        <!-- <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row mt-4 pt-2" v-if="new_user.create_account">
                                            <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                                <input data-lpignore="true" placeholder=" " type="password" @focus="validation.new_user.password.state = null" v-model="new_user.password">
                                                <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password.state == false}">{{validation.new_user.password.message}}</div>
                                                <label class="full-input__after-input">
                                                    {{$root.translateString('password')}}
                                                </label>
                                            </div>
                                            <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                                <div class="full-input__field-gr">
                                                    <input data-lpignore="true" placeholder=" " type="password" @focus="validation.new_user.password_confirmation.state = null" v-model="new_user.password_confirmation">
                                                    <div class="invalid-feedback" :class="{'d-block' : validation.new_user.password_confirmation.state == false}">{{validation.new_user.password_confirmation.message}}</div>
                                                    <label class="full-input__after-input">
                                                        {{$root.translateString('password_confirmation')}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div> -->

                                    </div>
                                </div>

                            </div>

                            <!-- ///////////////////// SPEDIZIONE -->

                            <div v-if="should_be_shipped" class="w-full relative">

                                <div class="relative w-full flex items-center space-x-4 mb-12">
                                    <span class="bg-primary/10 p-3 w-10 h-10 flex justify-center items-center text-primary text-base rounded-full">
                                        <span v-if="!isLogged">2</span>
                                        <span v-else>1</span>
                                    </span>
                                    <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase text-center">
                                        {{$root.translateString('shipping_details')}}
                                    </span>
                                </div>

                                <div>
                                    <div class="relative w-full grid lg:grid-cols-2 gap-y-10 sm:gap-y-10 2xl:gap-y-10 gap-x-10 xl:gap-x-12 2xl:gap-x-14">

                                        <span class="relative w-full block col-span-2">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input data-lpignore="true" @focus="validation.address.name.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="address.name" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                    {{$root.translateString('name')}}
                                                </label>
                                            </span>
                                            <span v-if="validation.address.name.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.name.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input data-lpignore="true" @focus="validation.address.phone.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="tel" v-model="address.phone" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                    {{$root.translateString('phone')}}
                                                </label>
                                            </span>
                                            <span v-if="validation.address.phone.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.phone.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block pointer-events-none col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">

                                                <v-select
                                                    @input="validation.address.country.state = null"
                                                    v-model="address.country"
                                                    :class="{'full' : (address.country != null && address.country != '')}"
                                                    :options="countries"
                                                    label="value"
                                                    index="label"
                                                    :reduce="label => label.label"
                                                    class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none pointer-events-none"
                                                >
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                                        </template>
                                                    </template>
                                                </v-select>

                                                <label
                                                    class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left"
                                                >
                                                    {{$root.translateString('country')}}
                                                </label>

                                            </span>
                                            <span v-if="validation.address.country.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.country.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input data-lpignore="true" @focus="validation.address.address.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="address.address" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                    {{$root.translateString('address')}}
                                                </label>
                                            </span>
                                            <span v-if="validation.address.address.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.address.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input data-lpignore="true" @focus="validation.address.city.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="address.city" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                    {{$root.translateString('city')}}
                                                </label>
                                            </span>
                                            <span v-if="validation.address.city.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.city.message }}
                                            </span>
                                        </span>

                                        <span v-if="address.country.toLowerCase() == 'it' || address.country.toLowerCase() == ''" class="relative w-full block col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">

                                                <v-select
                                                    @input="validation.address.province.state = null"
                                                    v-model="address.province"
                                                    :options="provinces"
                                                    label="value"
                                                    index="label"
                                                    :reduce="label => label.label"
                                                    @search:focus="provinceFocusAddress = true"
                                                    @search:blur="provinceFocusAddress = false"
                                                    class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none"
                                                >
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                                        </template>
                                                    </template>
                                                </v-select>

                                                <label
                                                    class="-top-0.5 text-black text-xs sm:text-sm xl:text-xs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:!text-black peer-placeholder-shown:text-xs peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left"
                                                    :class="((address.province != null && address.province != '') || provinceFocusAddress) && '!text-customGray-text !text-xxs sm:!text-xs xl:!text-xxs !-top-5.5'"
                                                    >
                                                    {{$root.translateString('province')}}
                                                </label>

                                            </span>
                                            <span v-if="validation.address.province.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.province.message }}
                                            </span>
                                        </span>

                                        <span class="relative w-full block col-span-2 xl:col-span-1">
                                            <span class="w-full flex flex-col relative text-black">
                                                <input data-lpignore="true" @focus="validation.address.cap.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="number" v-model="address.cap" />
                                                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                    {{$root.translateString('cap')}}
                                                </label>
                                            </span>
                                            <span v-if="validation.address.cap.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                                {{ validation.address.cap.message }}
                                            </span>
                                        </span>

                                        <!-- <span class="flex flex-col sm:flex-row space-y-10 sm:space-y-0 w-full justify-start items-center col-span-2">
                                            <span class="flex items-center space-x-3">
                                                <span class="h-6 w-6 relative block flex-shrink-0">
                                                    <input name="marketing" id="marketing" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="marketing">
                                                    <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-black"></span>
                                                </span>
                                                <label for="marketing" class="cursor-pointer">
                                                    <span class="text-black/50 block text-xs sm:text-sm xl:text-xs !leading-none">
                                                        {{$root.translateString('marketing')}}
                                                    </span>
                                                </label>
                                            </span>
                                        </span> -->

                                        <!-- <div class="checkout-container-row-2__checkbox mt-3" v-if="(!hide_save_address || new_user.create_account) && should_be_shipped">
                                            <div class="checkbox-styles">
                                                <div class="checkbox">
                                                    <input data-lpignore="true" type="checkbox" id="save_new_address" v-model="save_new_address">
                                                    <label class="d-inline-block w-100" for="save_new_address"></label>
                                                </div>
                                                <label for="save_new_address" class="checkbox-styles__link mb-0">
                                                    {{$root.translateString('save-new-address')}}
                                                </label>
                                            </div>
                                        </div> -->

                                        <!-- <span class="flex flex-col sm:flex-row space-y-10 sm:space-y-0 w-full justify-center items-center">
                                            <span class="flex-grow">
                                                <span class="flex items-center space-x-3">
                                                    <span class="w-[30px] h-[30px] relative block">
                                                        <input name="require-invoice" id="require-invoice" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="user.billing.require_invoice">
                                                        <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-customGray-border/50"></span>
                                                    </span>
                                                    <label for="require-invoice" class="cursor-pointer">
                                                        <span class="text-black/50 text-lg lg:text-xl">{{$root.translateString('ask_for_invoice')}}</span>
                                                    </label>
                                                </span>
                                            </span>
                                        </span> -->

                                    </div>
                                </div>

                            </div>

                            <!-- ////////////////////// FATTURAZIONE -->

                            <div v-if="user.billing.require_invoice" class="w-full relative">

                                <div class="relative w-full flex items-center space-x-4 mb-12">
                                    <span class="bg-primary/10 p-3 w-10 h-10 flex justify-center items-center text-primary text-base rounded-full">
                                        <span v-if="!isLogged">3</span>
                                        <span v-else>2</span>
                                    </span>
                                    <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase text-center">
                                        {{$root.translateString('invoice_details')}}
                                    </span>
                                </div>

                                <div class="w-auto h-auto relative flex mt-12 mb-12 gap-x-4">
                                    <button @click="billing.type = 'private'" type="button" class="relative inline-flex">
                                        <span class="text-black opacity-50 text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium !leading-tight xl:hover:opacity-80 transition-all peer" :class="billing.type == 'private' && '!opacity-100'">
                                            {{$root.translateString('private')}}
                                        </span>
                                        <span v-if="billing.type == 'private'" class="absolute top-[calc(100%+.15rem)] w-full h-[1px] bg-black left-0 peer-[&.active]:!block z-20"></span>
                                    </button>

                                    <button  @click="billing.type = 'company'" type="button" class="relative inline-flex">
                                        <span class="text-black opacity-50 text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium !leading-tight xl:hover:opacity-80 transition-all peer"  :class="billing.type == 'company' && '!opacity-100'">
                                            {{$root.translateString('company')}}
                                        </span>
                                        <span v-if="billing.type == 'company'" class="absolute top-[calc(100%+.15rem)] w-full h-[1px] bg-black left-0 peer-[&.active]:!block z-20"></span>
                                    </button>
                                </div>

                                <div class="relative w-full grid lg:grid-cols-2 gap-y-10 sm:gap-y-10 2xl:gap-y-10 gap-x-10 xl:gap-x-12 2xl:gap-x-14">

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.name.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.name" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('company_name')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.name.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.name.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.fiscal_code.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none uppercase" placeholder=" " type="text" v-model="billing.fiscal_code" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('vat')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.fiscal_code.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.fiscal_code.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.pec.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="email" v-model="billing.pec" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('pec')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.pec.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.pec.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.sdi.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.sdi" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('sdi')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.sdi.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.sdi.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.address.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.address" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('address')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.address.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.address.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.city.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.city" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('city')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.city.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.city.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">

                                            <v-select
                                            @input="validation.billing.province.state = null"
                                                v-model="billing.province"
                                                :options="provinces"
                                                label="value"
                                                index="label"
                                                :reduce="label => label.label"
                                                @search:focus="provinceFocusBilling = true"
                                                @search:blur="provinceFocusBilling = false"
                                                    class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none"
                                                >
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                                        </template>
                                                    </template>
                                                </v-select>

                                                <label
                                                    class="-top-0.5 text-black text-xs sm:text-sm xl:text-xs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:!text-black peer-placeholder-shown:text-xs peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left"
                                                    :class="((billing.province != null && billing.province != '') || provinceFocusBilling) && '!text-customGray-text !text-xxs sm:!text-xs xl:!text-xxs !-top-5.5'"
                                                    >
                                                    {{$root.translateString('province')}}
                                                </label>

                                        </span>
                                        <span v-if="validation.billing.province.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.province.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'company'" class="relative w-full block col-span-2 xl:col-span-1">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.cap.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.cap" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('cap')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.cap.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.cap.message }}
                                        </span>
                                    </span>

                                    <span v-if="billing.type == 'private'" class="relative w-full block col-span-2">
                                        <span class="w-full flex flex-col relative text-black">
                                            <input data-lpignore="true" @focus="validation.billing.fiscal_code.state = null" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="billing.fiscal_code" />
                                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">
                                                {{$root.translateString('fiscal_code')}}
                                            </label>
                                        </span>
                                        <span v-if="validation.billing.fiscal_code.state != null" class="invalid text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                                            {{ validation.billing.fiscal_code.message }}
                                        </span>
                                    </span>

                                    <!-- <div class="checkout-container-row-2__checkbox mt-2 mt-lg-5" v-if="!hide_save_billing_info || new_user.create_account">
                                        <div class="checkbox-styles">
                                            <div class="checkbox">
                                                <input data-lpignore="true" type="checkbox" id="save_billing_info" class="cb" name="save_billing_info" v-model="save_billing_info">
                                                <label for="save_billing_info"></label>
                                            </div>
                                            <label for="save_billing_info" class="checkbox-styles__link checkout mb-0">
                                                <span>{{$root.translateString('update-billing-data')}}</span>
                                            </label>
                                        </div>
                                    </div> -->

                                </div>

                            </div>

                            <!-- ////////////////////// PAGAMENTO -->

                            <div class="w-full relative">

                                <div class="relative w-full flex items-center space-x-4 mb-6 md:mb-12">
                                    <span class="bg-primary/10 p-3 w-10 h-10 flex justify-center items-center text-primary text-base rounded-full">
                                        <template v-if="address.country == 'IT'">
                                            <span v-if="!isLogged">4</span>
                                            <span v-else>3</span>
                                        </template>
                                        <template v-else>
                                            <span>2</span>
                                        </template>
                                    </span>
                                    <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase text-center">
                                        <span class="xs:hidden">{{$root.translateString('payment_methods_short')}}</span>
                                        <span class="hidden xs:inline">{{$root.translateString('payment_methods')}}</span>
                                    </span>
                                </div>

                                <div class="relative w-full flex flex-col">

                                    <button type="button" @click="pay.method = 'stripe'" class="flex flex-col xs:flex-row xs:items-center border-b border-customGray-border/50 py-6 space-x-3 cursor-pointer">
                                        <span class="flex-grow flex items-center space-x-2 xs:space-x-3">
                                            <span class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-customGray-border/50" :class="pay.method == 'stripe' && '!border-primary'">
                                                <span v-if="pay.method == 'stripe'" class="w-2 h-2 block bg-primary rounded-full"></span>
                                            </span>
                                            <span class="flex-grow flex flex-col items-start pl-2">
                                                <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase">
                                                    {{$root.translateString('credit_card')}}
                                                </span>
                                                <span class="flex !leading-none text-left items-center text-customGray-text pt-1.5 xl:pt-1 text-xs md:text-sm xl:text-xs" v-if="pay.method == 'stripe'">
                                                    {{$root.translateString('credit_card_p')}}
                                                </span>
                                            </span>
                                        </span>
                                        <span class="h-full flex items-center pt-3 pl-6 xs:pt-0 xs:pl-0">
                                            <img class="h-7 w-auto" src="/images/svg/credit-card.svg" alt="Carta di credito" height="25"/>
                                        </span>
                                    </button>

                                    <button type="button" @click="pay.method = 'bank'" class="flex flex-col xs:flex-row xs:items-center border-b border-customGray-border/50 py-6 space-x-3 cursor-pointer">
                                        <span class="flex-grow flex items-center space-x-2 xs:space-x-3">
                                            <span class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-customGray-border/50" :class="pay.method == 'bank' && '!border-primary'">
                                                <span v-if="pay.method == 'bank'" class="w-2 h-2 block bg-primary rounded-full"></span>
                                            </span>
                                            <span class="flex-grow flex flex-col items-start pl-2">
                                                <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase">
                                                    {{$root.translateString('wire_transfer')}}
                                                </span>
                                                <span class="flex !leading-none text-left items-center text-customGray-text pt-1.5 xl:pt-1 text-xs md:text-sm xl:text-xs" v-if="pay.method == 'bank'">
                                                    {{$root.translateString('wire_transfer_p')}}
                                                </span>
                                            </span>
                                        </span>
                                        <span class="h-full flex items-center pt-3 pl-6 xs:pt-0 xs:pl-0">
                                            <img class="h-7 w-auto" src="/images/svg/bankwire.svg" alt="Bonifico bancario" height="25"/>
                                        </span>
                                    </button>

                                    <button type="button" @click="pay.method = 'paypal'" class="flex flex-col xs:flex-row xs:items-center border-b border-customGray-border/50 py-6 space-x-3 cursor-pointer">
                                        <span class="flex-grow flex items-center space-x-2 xs:space-x-3">
                                            <span class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-customGray-border/50" :class="pay.method == 'paypal' && '!border-primary'">
                                                <span v-if="pay.method == 'paypal'" class="w-2 h-2 block bg-primary rounded-full"></span>
                                            </span>
                                            <span class="flex-grow flex flex-col items-start pl-2">
                                                <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase">
                                                    Paypal
                                                </span>
                                                <span class="flex !leading-none text-left items-center text-customGray-text pt-1.5 xl:pt-1 text-xs md:text-sm xl:text-xs" v-if="pay.method == 'paypal'">
                                                    {{$root.translateString('paypal_p')}}
                                                </span>
                                            </span>
                                        </span>
                                        <span class="h-full flex items-center pt-3 pl-6 xs:pt-0 xs:pl-0">
                                            <img class="h-7 w-auto" src="/images/svg/paypal.svg" alt="Paypal" height="25"/>
                                        </span>
                                    </button>

                                    <!-- <button type="button" @click="pay.method = 'applePay'" class="flex flex-col xs:flex-row xs:items-center border-b border-customGray-border/50 py-6 space-x-3 cursor-pointer" v-if="paymentRequest != null">
                                        <span class="flex-grow flex items-center space-x-2 xs:space-x-3">
                                            <span class="flex justify-center items-center min-w-[20px] min-h-[20px] rounded-full border border-customGray-border/50" :class="pay.method == 'applePay' && '!border-primary'">
                                                <span v-if="pay.method == 'applePay'" class="w-2 h-2 block bg-primary rounded-full"></span>
                                            </span>
                                            <span class="flex-grow flex flex-col items-start pl-2">
                                                <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase">
                                                    Apple Pay / Google Pay
                                                </span>
                                                <span class="flex !leading-none text-left items-center text-customGray-text pt-1.5 xl:pt-1 text-xs md:text-sm xl:text-xs" v-if="pay.method == 'applePay'">
                                                    {{$root.translateString('apple_pay_p')}}
                                                </span>
                                            </span>
                                        </span>
                                        <span class="h-full flex items-center pt-3 pl-6 xs:pt-0 xs:pl-0">
                                            <img class="h-7 w-auto" src="/images/svg/apple-google-pay.svg" alt="Apple Pay - Google Pay" height="25"/>
                                        </span>
                                    </button> -->

                                </div>

                            </div>

                            <!-- ////////////////////// MESSAGGIO -->

                            <div class="w-full relative">

                                <div class="relative w-full flex items-center space-x-4 mb-12">
                                    <span class="bg-primary/10 p-3 w-10 h-10 flex justify-center items-center text-primary text-base rounded-full">
                                        <template v-if="address.country == 'IT'">
                                            <span v-if="!isLogged">5</span>
                                            <span v-else>4</span>
                                        </template>
                                        <template v-else>
                                            <span>3</span>
                                        </template>
                                    </span>
                                    <span class="text-black text-sm sm:text-base tracking-[.15rem] uppercase text-left">
                                        {{$root.translateString('ask_for_gift')}}
                                    </span>
                                </div>

                                <div class="relative w-full flex flex-col mb-20">

                                    <span v-if="giftPack.status" class="relative w-full block">
                                        <span class="w-full flex flex-col relative text-black">
                                            <textarea rows="3" class="p-3 md:p-4 xl:p-5 border-b !border-customGray-border bg-transparent !outline-none !shadow-none h-[100px] text-black text-xs sm:text-sm xl:text-xs peer !ring-0 !ring-transparent" placeholder=" " v-model="giftPack.message"></textarea>
                                            <!-- <label class="text-black text-xxs absolute left-0 -top-5 tracking-[.15rem] opacity-50 pointer-events-none peer-focus:!text-xxs peer-focus:-top-5 peer-placeholder-shown:text-sm peer-placeholder-shown:xl:text-xbase peer-placeholder-shown:top-0 transition-all w-full text-center uppercase">
                                                {{$root.translateString('giftpack_title')}}
                                            </label> -->
                                        </span>
                                    </span>

                                </div>

                            </div>

                        </div>

                        <!-- -->

                        <div class="flex flex-col w-full space-y-8 xl:w-[460px] xl:sticky xl:top-6 self-start">

                            <div class="p-6 sm:p-10 xl:p-12 text-sm text-secondary-400 bg-customGray-background/40">

                                <!-- <h4 class="text-black text-lg tracking-[.15rem] uppercase text-center mb-6 xl:-mt-2">
                                    {{$root.translateString('summary')}}
                                </h4> -->

                                <div class="relative w-full flex flex-col space-y-6 pb-6 mb-6 border-b border-customGray-border/50">

                                    <div class="flex items-start" v-for="(item, key) in cart" :key="key">
                                        <div class="w-16 h-16 md:w-18 md:h-18 flex-shrink-0 flex justify-center items-center bg-customGray-background/50 p-3">
                                            <img width="70" class="w-full h-full object-contain relative -top-1" :src="item.options.image" :alt="item.options.name" />
                                        </div>
                                        <div class="flex flex-col flex-grow pl-5 self-center">
                                            <div class="flex flex-grow pl-0 pt-0 w-full items-start">
                                                <div class="flex">
                                                    <span class="pr-2 h-full whitespace-nowrap text-sm sm:text-base !leading-snug relative -top-0.5">{{item.qty}} x</span>
                                                        <span class="flex-grow flex flex-col">
                                                            <span class="uppercase text-sm sm:text-base text-black !leading-tight" v-text="item.options.name"></span>
                                                            <span class="w-full flex flex-col !leading-snug text-customGray-text">
                                                                <span class="w-full" v-if="item.options.type != 'visite'" v-text="item.options.combination"></span>
                                                                <span class="w-full" v-else-if="item.options.type == 'visite'">
                                                                    {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                                    <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                                    <span v-else>{{$root.translateString('people')}}</span>
                                                                    <span v-if="item.options.combination">
                                                                        -
                                                                    {{item.options.combination.replace(" ", "")}}
                                                                    </span>
                                                                </span>
                                                                <span class="w-full" v-else> Distilleria Francesco </span>
                                                            </span>
                                                        </span>
                                                </div>

                                            </div>
                                            <div class="py-0 flex w-full items-center flex-grow mt-2 pl-0">
                                                <span class="flex-grow text-right">
                                                    € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="xl:-mt-2 mb-4 w-full bg-customGray-background/50 px-6 py-3 flex justify-center items-center">
                                    <span class="text-black uppercase font-medium tracking-[.15rem]">{{$root.translateString('free_shipping')}} <span>€110</span></span>
                                </div>

                                <div class="pb-4 mb-4 text-center text-primary border-b border-customGray-border/50" v-if="missing_for_free_shipping > 0">
                                    <span v-if="lang == 'it'">
                                        Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                                    </span>
                                    <span v-else>
                                        € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                                    </span>
                                </div>

                                <div class="flex pb-2">
                                    <div class="flex-grow">{{$root.translateString('subtotal')}}</div>
                                    <div class="">
                                        € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                                    </div>
                                </div>

                                <div class="spedizione flex pb-4" v-if="should_be_shipped">
                                    <div class="flex-grow">{{$root.translateString('shipping')}}</div>
                                    <div class="">
                                        <span v-if="shipping > 0">
                                            € {{ $root.currencyDisplaySimple(shipping) }}
                                        </span>
                                        <span v-else>{{$root.translateString('free')}}</span>
                                    </div>
                                </div>

                                <div class="spedizione flex pb-4" v-if="discount > 0">
                                    <div class="flex-grow">{{$root.translateString('discount')}}</div>
                                    <div class="">
                                        € {{ $root.currencyDisplaySimple(discount) }}
                                    </div>
                                </div>

                                <div class="flex py-3 border-t border-customGray-border/50">
                                    <div class="flex flex-grow flex-col">
                                        <div class="">{{$root.translateString('total')}}</div>
                                        <small class="-mt-1 text-black">{{$root.translateString('tax_included')}}</small>
                                    </div>
                                    <div class="text-black"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                                </div>

                                <div class="text-center w-full mt-1 pt-2">
                                    <div class="flex w-full">

                                        <!-- v-if="pay.method != 'applePay'" -->

                                        <button type="button" @click="createOrder" :class="{'loading' : loading}" :disabled="btn_disabled" class="relative w-full lg:px-16 py-5 mb-2 flex items-center bg-customGray-background transition-all !duration-500 mx-auto xl:hover:!rounded-lg group">
                                            <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                                            <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                                            <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                                                {{$root.translateString('complete_order')}}
                                            </span>
                                        </button>

                                        <!-- <button type="button" v-else @click="paymentRequest.show();createOrder()" :class="{'loading' : loading}" :disabled="btn_disabled" class="relative w-full lg:px-16 py-5 mb-2 flex items-center bg-customGray-background transition-all !duration-500 mx-auto xl:hover:!rounded-lg group">
                                            <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                                            <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                                            <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                                                {{$root.translateString('complete_order')}}
                                            </span>
                                        </button> -->

                                    </div>
                                </div>

                                <!-- ////////////////////// TERMINI-->

                                <!-- <div class="w-full relative border-t border-customGray-border/50 pt-4 mt-7 2xl:-mb-2 px-5">

                                    <span class="text-secondary-400 uppercase text-xs space-x-2 space-y-1.5 !leading-normal block text-center" v-html="$root.translateString('before-buy')"></span>

                                </div> -->

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </main>

    </div>

</template>

<script>

    import moment from 'moment'

    export default {
        props: ['lang', 'provinces', 'countries', 'isLogged', 'userProp'],
        data() {
            return {
                user: {
                    addresses: [],
                    billing: {
                        require_invoice: true,
                        data: {
                            type: 'private',
                            name: '',
                            fiscal_code: '',
                            sdi: '',
                            pec: '',
                            address: '',
                            city: '',
                            cap: '',
                            province: '',
                            country: 'IT',
                        }
                    },
                },
                provinceFocusAddress: false,
                provinceFocusBilling: false,
                hide_save_billing_info: true,
                save_billing_info: false,
                save_new_address: false,
                hide_save_address: true,
                marketing: false,
                new_user: {
                    name: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                    create_account: false,
                },
                hasGift: false,
                stripeObject: null,
                paymentRequest: null,
                loading: false,
                pay: {
                    method: 'stripe'
                },
                discount_placeholder: true,
                giftPack: {
                    status: true,
                    message: '',
                },
                address: {
                    name: '',
                    address: '',
                    city: '',
                    cap: '',
                    province: '',
                    country: 'IT',
                },
                billing: {
                    type: 'private',
                    name: '',
                    fiscal_code: '',
                    sdi: '',
                    pec: '',
                    address: '',
                    city: '',
                    cap: '',
                    province: '',
                    country: 'IT',
                },
                discountCode: '',
                cartRaw: null,
                priceTotalWt: 0,
                finalPrice: 0,
                shipping: 0,
                discount: 0,
                count: 0,
                showDiscountBox: false,
                missing_for_free_shipping: 0,
                validation: {
                    new_user: {
                        name: {
                            state: null,
                            message: '',
                        },
                        email: {
                            state: null,
                            message: '',
                        },
                        phone: {
                            state: null,
                            message: '',
                        },
                        password: {
                            state: null,
                            message: '',
                        },
                        password_confirmation: {
                            state: null,
                            message: '',
                        },
                        privacy: {
                            state: null,
                            message: '',
                        },
                    },
                    address: {
                        name: {
                            state: null,
                            message: '',
                        },
                        phone: {
                            state: null,
                            message: '',
                        },
                        address: {
                            state: null,
                            message: '',
                        },
                        /*email: {
                            state: null,
                            message: '',
                        },*/
                        city: {
                            state: null,
                            message: '',
                        },
                        cap: {
                            state: null,
                            message: '',
                        },
                        province: {
                            state: null,
                            message: '',
                        },
                        country: {
                            state: null,
                            message: '',
                        },
                        /*privacy: {
                            state: null,
                            message: '',
                        },*/
                    },
                    billing: {
                        name: {
                            state: null,
                            message: '',
                        },
                        fiscal_code: {
                            state: null,
                            message: '',
                        },
                        sdi: {
                            state: null,
                            message: '',
                        },
                        pec: {
                            state: null,
                            message: '',
                        },
                        address: {
                            state: null,
                            message: '',
                        },
                        city: {
                            state: null,
                            message: '',
                        },
                        cap: {
                            state: null,
                            message: '',
                        },
                        province: {
                            state: null,
                            message: '',
                        },
                        country: {
                            state: null,
                            message: '',
                        },
                    },
                    discount: {
                        state: null,
                        message: ''
                    },
                },
                btn_disabled: false,
                profile_loaded: false,
                billing_memo: null,
                should_be_shipped: false,
            }
        },
        created() {

            if(typeof this.userProp != 'undefined' && this.isLogged) {
                if(typeof this.userProp.billing !== 'undefined' && this.userProp.billing != null) {
                    this.$set(this.user, 'billing', this.userProp.billing);
                };

                this.$set(this.user, 'addresses', this.userProp.addresses);

                let new_address = {
                    new: true,
                    label: 'Usa nuovo indirizzo',
                    name: '',
                    address: '',
                    city: '',
                    cap: '',
                    province: '',
                    country: 'IT',
                };

                for(let i=0; i< this.user.addresses.length; i++) {
                    this.$set(this.user.addresses[i], 'new', false);
                    this.$set(this.user.addresses[i], 'label', this.user.addresses[i].address + ' - ' + this.user.addresses[i].cap + ' - ' + this.user.addresses[i].city + ' (' + this.user.addresses[i].province + ')');
                }

                if(this.user.addresses.length == 0) {
                    this.hide_save_address = false;
                }

                this.user.addresses.push(new_address);

                this.address = this.user.addresses[0];
                this.billing = this.user.billing.data;

                this.billing_memo = JSON.parse(JSON.stringify(this.billing));

            }

            if(this.isLogged && this.userProp.billing == null) {
                this.hide_save_billing_info = false;
            }

            this.getCart();
        },
        watch: {
            billing: {
                handler: function (n, o) {
                    if(this.profile_loaded && this.isLogged && this.userProp.billing != null) {
                        if(JSON.stringify(n) != JSON.stringify(this.billing_memo)) {
                            this.hide_save_billing_info = false;
                        }else{
                            this.hide_save_billing_info = true;
                        }
                    }
                },
                deep: true,
            },
            'user.billing.require_invoice' : {
                handler: function (n, o) {
                    if(!n && this.isLogged) {
                        this.billing = this.billing_memo;
                    }
                },
                deep: true,
            },
            'address.country' : {
                handler: function (n, o) {
                    if(n != 'IT') {
                        this.pay.method = 'bank';
                        this.address.province = '';
                        this.user.billing.require_invoice = false;
                    }else{
                        this.pay.stripe = 'stripe';
                    }
                }
            }
        },
        mounted() {

            this.$eventHub.$on('discount.applied', payload => {
                this.getCart();
            });

        },
        methods: {
            summonPopup() {
                this.$eventHub.$emit('login', {'hide_register': true});
            },
            manageSaveAddressCheckbox() {
                if(this.address.new) {
                    this.hide_save_address = false;
                } else {
                    this.hide_save_address = true;
                    this.save_new_address = false;
                }
            },
            toggleLogin() {
                this.$eventHub.$emit('login', {});
            },
            loadStripe() {
                axios.get('/api/cart/stripe')
                .then(response => {
                    this.stripeObject = Stripe(response.data.pkey);

                    var paymentRequest = this.stripeObject.paymentRequest({
                        country: 'IT',
                        currency: 'eur',
                        total: {
                            label: 'Ordine Shop ',
                            amount: parseInt(parseFloat(this.finalPrice) * 100),
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                    });

                    // Check the availability of the Payment Request API first.
                    paymentRequest.canMakePayment().then(result => {
                        if (result) {
                            this.paymentRequest = paymentRequest;
                        } else {
                            this.paymentRequest = null
                        }
                    });
                })
            },
            getCart() {
                axios.get('/api/cart/get')
                .then(response => {
                    this.cartRaw = response.data.cart;
                    this.count = response.data.count;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.shipping = response.data.shipping;
                    this.discount = response.data.discount;
                    this.missing_for_free_shipping = response.data.missingForFreeShipping;
                    this.should_be_shipped = response.data.shouldBeShipped;
                    this.hasGift = response.data.hasGift;
                    this.loadStripe();

                    if(!this.should_be_shipped) {
                        this.hide_save_address = true;
                    }

                    if(this.cart.length == 0) {
                        window.location.href = '/carrello';
                    }else{

                        let products_gtm = [];

                        Object.keys(this.cart).forEach(key => {
                            let entry = {};
                            entry.item_id = this.cart[key].id;
                            entry.quantity = this.cart[key].qty;
                            entry.item_brand = '';
                            entry.item_name = this.cart[key].options.name.replace('<br>', ' ');
                            entry.price = String(this.cart[key].price).replace(',', '.');
                            entry.item_variant = this.cart[key].options.combination.toLowerCase();
                            entry.item_category = this.cart[key].options.type;
                            products_gtm.push(entry);
                        })

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "begin_checkout",
                            ecommerce: {
                                items: products_gtm
                            }
                        });

                        //

                        let temp_cart = [];
                        let temp_cart_ids = [];

                        Object.keys(this.cart).forEach(key => {
                            let entry = {};
                            entry.id = this.cart[key].name.replace('<br>', ' ');
                            entry.quantity = this.cart[key].qty;
                            temp_cart.push(entry);
                            temp_cart_ids.push(entry.id);
                        })

                        fbq('track', 'InitiateCheckout',
                            {
                                content_category: "checkout",
                                content_ids: temp_cart_ids,
                                contents: temp_cart,
                                currency: 'EUR',
                                num_items: this.cart.length,
                                value: this.finalPrice
                            }
                        );

                        this.profile_loaded = true;

                    }

                });
            },
            createOrder()
            {
                this.btn_disabled = true;
                if(this.canProceed()){
                    this.loading = true;

                    if(this.giftPack.message == '') {
                        this.giftPack.status = false;
                    }

                    axios.post('/api/cart/create-order', {
                        lang: this.lang,
                        pay: this.pay.method,
                        address: this.address,
                        save_new_address: this.save_new_address,
                        save_billing_info: this.save_billing_info,
                        new_user: this.new_user,
                        require_invoice: this.user.billing.require_invoice,
                        billing: this.billing,
                        discountCode: this.discountCode,
                        giftPack: this.giftPack,
                        marketing: this.marketing
                    })
                        .then(response => {
                            if(response.data.action == 'stripe_js') {
                                //var stripe = Stripe(response.data.pkey);
                                this.stripeObject.redirectToCheckout({
                                    sessionId: response.data.payment_intent
                                }).then(function (result) {
                                    (result.error.message)
                                    this.btn_disabled = false;
                                });
                            } else if(response.data.action == 'stripe_apple_pay') {
                                var stripe = this.stripeObject;
                                var clientSecret = response.data.client_secret;
                                var confirm_page = response.data.confirm_page;
                                this.paymentRequest.on('paymentmethod', ev => {
                                    stripe.confirmCardPayment(
                                        clientSecret,
                                        {payment_method: ev.paymentMethod.id},
                                        {handleActions: false}
                                    ).then(function(confirmResult) {
                                        //console.log(confirmResult);
                                        if (confirmResult.error) {
                                            ev.complete('fail');
                                        } else {
                                            ev.complete('success');
                                            stripe.confirmCardPayment(response.data.client_secret).then(function(result) {
                                                if (result.error) {
                                                // The payment failed -- ask your customer for a new payment method.
                                                } else {
                                                    window.location.href = confirm_page;
                                                }
                                            });
                                        }
                                    });
                                });
                            } else if(response.data.action == 'redirect') {
                                window.location.href = response.data.next_action;
                            }
                        }).catch(e => {
                            if(typeof e.response.data.location != 'undefined') {
                                window.location.href = e.response.data.location;
                            } else {
                                window.location.reload(true);
                            }
                        })
                }
            },
            isNotEmpty(object) {
                return (_.isEmpty(object) === false);
            },
            canProceed(){

                let is_invalid = false;

                /* */

                if(!this.isLogged) {

                    Object.keys(this.validation.new_user).forEach((elem, key) => {
                        this.validation.new_user[elem].message = '';
                        this.validation.new_user[elem].state = null;
                    });

                    if (this.new_user.name == '') {
                        if(this.lang == 'it') {
                            this.validation.new_user.name.message = 'Questo campo non può essere vuoto.';
                        }else{
                            this.validation.new_user.name.message = 'This field cannot be empty.';
                        }
                        this.validation.new_user.name.state = false;
                        is_invalid = true;
                    }else{
                        this.validation.new_user.name.state = null;
                    }

                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let disposable = require('is-disposable-email');
                    if (! re.test(this.new_user.email)) {
                        if(this.lang == 'it') {
                            this.validation.new_user.email.message = 'Non sembra un indirizzo email valido.';
                        }else{
                            this.validation.new_user.email.message = 'The email address is invalid.';
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        if (disposable(this.new_user.email)) {
                            if(this.lang == 'it') {
                                this.validation.new_user.email.message = 'Tipologia di servizio email non valido.';
                            }else{
                                this.validation.new_user.email.message = 'You email provider is invalid.';
                            }
                            this.validation.new_user.email.state = false;
                            is_invalid = true;
                        } else {
                            this.validation.new_user.email.state = null;
                        }
                    }

                    if (this.new_user.create_account) {

                        if (this.new_user.password == '') {
                            if(this.lang == 'it') {
                                this.validation.new_user.password.message = 'Questo campo non può essere vuoto.';
                            }else{
                                this.validation.new_user.password.message = 'This field cannot be empty.';
                            }
                            this.validation.new_user.password.state = false;
                            is_invalid = true;
                        }else{
                            this.validation.new_user.password.state = null;
                        }

                        if (this.new_user.password_confirmation != this.new_user.password || this.user.password_confirmation == '') {
                            if(this.lang == 'it') {
                                this.validation.new_user.password_confirmation.message = 'Questo campo deve coincidere con la password.';
                            }else{
                                this.validation.new_user.password_confirmation.message = 'Questo campo non può essere vuoto.';
                            }
                            this.validation.new_user.password_confirmation.state = false;
                            is_invalid = true;
                        }else{
                            this.validation.new_user.password_confirmation.state = null;
                        }

                    }

                    if(!this.new_user.privacy) {
                        if(this.lang == 'it') {
                            this.validation.new_user.privacy.message = 'È necessario accettare i termini.';
                        }else{
                            this.validation.new_user.privacy.message = 'You need to accept the terms.';
                        }
                        this.validation.new_user.privacy.state = false;
                        is_invalid = true;
                    }

                }

                /* */

                Object.keys(this.validation.address).forEach((elem, key) => {
                    this.validation.address[elem].message = '';
                    this.validation.address[elem].state = null;
                });

                Object.keys(this.validation.billing).forEach((elem, key) => {
                    this.validation.billing[elem].message = '';
                    this.validation.billing[elem].state = null;
                });

                if(this.should_be_shipped) {
                    $.each(this.address, (key, elem) => {
                        if(typeof this.validation.address[key] != 'undefined') {
                            if(elem == '') {

                                if(key == 'province' && this.address.country.toLowerCase() != 'it') {
                                    //do nothing
                                }else{
                                    if (this.lang == 'it') {
                                        this.validation.address[key].message = 'Il campo è obbligatorio';
                                    } else {
                                        this.validation.address[key].message = 'This field is required';
                                    }

                                    this.validation.address[key].state = false;
                                    is_invalid = true;
                                }

                            }
                        }
                    });
                }


                if(this.user.billing.require_invoice) {

                    if(this.billing.type == 'company') {

                        $.each(this.billing, (key, elem) => {
                            if(elem == '' && key != 'sdi' && key != 'pec'){
                                if(this.lang == 'it') {
                                    this.validation.billing[key].message = 'Il campo è obbligatorio';
                                }else{
                                    this.validation.billing[key].message = 'This field is required';
                                }
                                this.validation.billing[key].state = false;
                                is_invalid = true;
                            }
                        });

                        if(this.billing.sdi == '' && this.billing.pec == '') {
                            if(this.lang == 'it') {
                                this.validation.billing.pec.message = 'Compila PEC o Codice univoco';
                                this.validation.billing.sdi.message = 'Compila PEC o Codice univoco';
                            }else{
                                this.validation.billing.pec.message = 'Either one between PEC or SDI is required';
                                this.validation.billing.sdi.message = 'Either one between PEC or SDI is required';
                            }
                            this.validation.billing.pec.state = false;
                            this.validation.billing.sdi.state = false;

                            is_invalid = true;
                        }

                    }else{

                        if(this.billing.fiscal_code == '') {
                            if(this.lang == 'it') {
                                this.validation.billing.fiscal_code.message = 'Il campo è obbligatorio';
                            }else{
                                this.validation.billing.fiscal_code.message = 'This field is required';
                            }
                            this.validation.billing.fiscal_code.state = false;
                            is_invalid = true;
                        }else{
                            if(this.getAge() != null && this.getAge() < 18) {
                                if(this.lang == 'it') {
                                    this.validation.billing.fiscal_code.message = 'Devi essere maggiorenne per completare l\'acquisto';
                                }else{
                                    this.validation.billing.fiscal_code.message = 'You must be over 18 years of age to buy our products';
                                }
                                this.validation.billing.fiscal_code.state = false;
                                is_invalid = true
                            }
                        }
                    }

                }

                if(is_invalid) {

                    setTimeout( () => {

                        this.btn_disabled = false;

                        let elements = document.querySelectorAll('.invalid');

                        if(!elements.length) return

                        window.scroll({
                            top: parseInt(elements[0].getBoundingClientRect().top + window.scrollY) - 250,
                            behavior: "smooth",
                        });

                    }, 500);

                    return false;
                }

                /* */

                let temp_cart_ids = [];

                Object.keys(this.cart).forEach(key => {
                    temp_cart_ids.push(this.cart[key].name.replace('<br>', ' '));
                })

                fbq('track', 'AddPaymentInfo',
                    {
                        content_category: "checkout",
                        content_ids: temp_cart_ids,
                        currency: 'EUR',
                        value: this.finalPrice
                    }
                );

                /* */

                return true;

            },
            getAge() {

                const monthsRepo = {
                    "A" : "01",
                    "B" : "02",
                    "C" : "03",
                    "D" : "04",
                    "E" : "05",
                    "H" : "06",
                    "L" : "07",
                    "M" : "08",
                    "P" : "09",
                    "R" : "10",
                    "S" : "11",
                    "T" : "12"
                };

                return this.billing.fiscal_code.replace(/^(?:\w{6})(\d{2})(\w)(\d{2}).+$/, function(data, aa, mm, gg) {

                    let year = parseInt(aa, 10);
                    let century = (year < 9)? '20':'19';
                    year = [century, aa].join('');

                    let day = parseInt(gg, 10);
                    let sex = (day > 31)? 'F' : 'M';
                    if (sex === 'F') day -= 40;

                    let month = mm.toUpperCase();
                    month = monthsRepo[month];

                    let date = [day, month, year].join("/")

                    let result = null

                    try{
                        result = (moment(date, 'DD/MM/YYYY').fromNow(true)).replace(' years', '')
                    }catch(e) {
                        result = null
                    }

                    return result;

                });

            },
        },
        computed: {
            cart() {
                if(this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            managePaymentMethodsCardinal() {
                if(!this.isLogged) {
                    return this.user.billing.require_invoice == false ? '03. ' : '04. ';
                }else{
                    return this.user.billing.require_invoice == false ? '02. ' : '03. ';
                }
            }
        }
    }

</script>

<style lang="postCSS">



</style>
